import { BlendedTimesQueryModel } from './../query_models/blended_times_query_model';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';
import { OrderedTimeQueryModel } from '../query_models/ordered_time_query_model';
import { UnlockedTimeQuery } from '../query_models/unlocked_time_query';
import { IRawTimeOccurrenceDatatype, ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceEngine } from '../engines/time/time_engine';

// Given an array of existing TimeOccurrence blocks, add a new empty TimeOccurrence to the array.
function addNewPotentialTimeCommandDefinition(
  defineCommand: any,
  ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
  ngOrderedTimeQueryModel: OrderedTimeQueryModel,
  ngUnlockedTimeQuery: UnlockedTimeQuery,
  ngTimeOccurrenceEngine: TimeOccurrenceEngine,
  addBuiltTimeCommand: any,
  ngBlendedTimesQueryModel: BlendedTimesQueryModel
) {
  return defineCommand(
    'addNewPotentialTimeCommand',
    function addNewPotentialTimeCommand(deferred: any, potentialTimeBlock: IRawTimeOccurrenceDatatype) {
      const emptyTimeCheck: ITimeOccurrenceDatatype | undefined = ngTimeOccurrenceEngine.createNewHourTimeOccurrence(
        ngTimeOccurrenceDataSource.store,
        potentialTimeBlock
      );

      if (!!emptyTimeCheck) {
        addBuiltTimeCommand(emptyTimeCheck).then(function () {
          ngOrderedTimeQueryModel.run();
          ngUnlockedTimeQuery.run();
          ngBlendedTimesQueryModel.run();

          deferred.resolve(ngTimeOccurrenceDataSource);
        });
      } else {
        deferred.resolve(undefined);
      }
    }
  );
}

angular.module('ui-ng-calendar').factory('addNewPotentialTimeCommand', addNewPotentialTimeCommandDefinition);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/commands/add_new_potential_time.ts